import React, { FC } from 'react';

export const ArrowRight: FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="currentcolor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M22.4 22.72 21 21.31 25.3 17H2v-2h23.29l-4.3-4.3 1.41-1.41L29.12 16l-6.72 6.72Z" />
  </svg>
);
